<template>
    <div>
        <bootstrap-box>
            <template v-slot:header>
                <h3 class="box-header">
                    {{resource('PushNotifications_Index_CreateNotification_Header')}}
                </h3>
            </template>
            <template v-slot:body>
                <create @notification-created="refreshNotifications" />
            </template>
        </bootstrap-box>

        <bootstrap-box>
            <template v-slot:header>
                <h3 class="box-header">
                    {{resource('PushNotifications_Index_NotificationsList_Header')}}
                </h3>
            </template>
            <template v-slot:body>
                <list ref="notificationList" />
            </template>
        </bootstrap-box>
    </div>
</template>

<script>
    import api from './../api';
    
    import resourceMixin from "../../../Util/Mixins/resources";
    
    import BootstrapBox from "../../../Components/Util/BootstrapBox.vue";
    import Create from './Create.vue';
    import List from './List.vue';
    
    export default {
        name: 'push-notifications-index',
        mixins: [resourceMixin],
        components: {
            BootstrapBox,
            Create,
            List
        },
        created() {
            const vm = this;
            
            api.validateWritePermission().then(
                canWrite => vm.canWrite = canWrite,
                () => vm.canWrite = false
            );
        },
        methods: {
            refreshNotifications(){
                if(this.$refs.notificationList){
                    this.$refs.notificationList.reloadNotifications();
                }
            }
        },
        data: () => ({
            canWrite: false
        })
    }
</script>